module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXCAYAAAAV1F8QAAABZUlEQVRIibWWQStEURiGn5mIpYQmiZqFKaWsbMRCYsPWWqOUf+Bv2MmvsLVRVhYUyZRBYqKZBQspNMmro+/qus5V45556/SeW/d8z/1O3/nuQdK+fqouqSiJkCMPPAMPNl6BAjBDYHUAi7GQY0AFGG4HKK66zeeBE6ArY/wc8AHUcm7/EuBbYDAj4JeSGb0DL8AbsA50Zozv4k0Bq77KOpLUDFhxZVfTec9XXFomQxmziTTr3Ae6My8FAvWmgS7MC4FA7sh4t65iPhAA0g2MAKc+UNW8GAAUHZOqD/RoPhEA1Gd+7QNh9T8aADRufpAGagD9AUBz5lfJzhDp2M6RK/Gm9axWFPW1afP7NNAZsAScB8jqBnhKA+1Yj+rJCHH/uk03SXbvtimtGLCtW8sAXgbK308pHXcldovY/UfH3oit3/ratZQXtxMXllZBe7G1jb9AJUmHkmqWXaugSUlVSbeSFiTxCQsrzi4rs+WfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon13.png
// module id = 7lY6
// module chunks = 13 14